import types from 'constants/actionTypes';

const initialState = {
  messages: null,
  announcementsVisible: true,
};

const announcements = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
 
  switch (type) {
    case types.GET_ANNOUNCEMENTS_REQUEST_SUCCESS: {
      const messages = payload?.result?.messages || [];
      return { ...state, messages };
    }
 
    case types.CLOSE_ANNOUNCEMENTS: {
      const updatedMessages = state?.messages?.slice(1) || [];
      return {
        messages: updatedMessages,
        announcementsVisible: !state.announcementsVisible,
      };
    }
 
    case types.GET_ANNOUNCEMENTS_REQUEST_FAILURE:
    default:
      return state;
  }
};

export default announcements;
